import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Define the async thunk for fetching account metrics
export const accountMetrics = createAsyncThunk(
  "accounts/fetchAccountMetrics",
  async ({ id, idToken }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      };

      const response = await axios.get(`account/metrics/${id}`, config);
      return response.data; // Assuming accountMetricsReq returns a response with data property
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const getPlans = createAsyncThunk(
  "account/fundingEvaluationPlans",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("account/funding-evaluation/");
      return response.data;
    } catch (error) {
      console.error("Error during get plans request:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getPlatform = createAsyncThunk(
  "account/platform-list",
  async ({ id, idToken }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      };
      const response = await axios.get("account/platform-list/", config);
      return response.data.filter((item) => item.platform?.toLowerCase().trim() !== "volumetrica");
    } catch (error) {
    console.error("Error during get platform-list request:", error);
    return rejectWithValue(error.response?.data || error.message);
  }
});

const initialState = {
  isLoading: false,
  isError: false,
  data: [],
  error: null,
  plans: {
    isLoading: false,
    isError: false,
    data: [],
    selected_challenge: null,
    error: null,
    lastPaymentId: null,
    platForm_list: [],
  },
  tradeDetails: null,
};

const accountMetricsSlice = createSlice({
  name: "accountMetrics",
  initialState,
  reducers: {
    resetAccountMetrics: (state) => {
      state.data = [];
      state.isLoading = false;
      state.isError = false;
      state.error = null;
      state.tradeDetails = null;
    },
    setSelectedChallenge: (state, action) => {
      state.plans.selected_challenge = action.payload;
    },
    setLastPayment: (state, action) => {
      state.plans.lastPaymentId = action.payload;
    },
    removeLastPayment: (state, action) => {
      state.plans.lastPaymentId = null;
    },
    setTradeDetails: (state, action) => {
      state.tradeDetails = action.payload || null;
    },
    clearTradeDetails: (state) => {
      state.tradeDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(accountMetrics.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(accountMetrics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(accountMetrics.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = "Failed to fetch account metrics";
        state.data = [];
      })
      .addCase(getPlans.pending, (state) => {
        state.plans.isLoading = true;
        state.plans.isError = false;
        state.plans.error = null;
      })
      .addCase(getPlans.fulfilled, (state, action) => {
        state.plans.isLoading = false;
        state.plans.data = action.payload;
      })
      .addCase(getPlans.rejected, (state, action) => {
        state.plans.isLoading = false;
        state.plans.isError = true;
        state.plans.error = action.payload || "Failed to fetch plans";
      })
      .addCase(getPlatform.pending, (state) => {
        state.plans.isLoading = true;
        state.plans.isError = false;
        state.plans.error = null;
      })
      .addCase(getPlatform.fulfilled, (state, action) => {
        state.plans.isLoading = false;
        state.plans.platForm_list = action.payload?.map((item) => ({
          label: item.platform,
          value: item.id,
        }));
      })
      .addCase(getPlatform.rejected, (state, action) => {
        state.plans.isLoading = false;
        state.plans.isError = true;
        state.plans.error = action.payload || "Failed to fetchPlatform";
      });
  },
});

export const {
  resetAccountMetrics,
  removeLastPayment,
  setLastPayment,
  setSelectedChallenge,
  clearTradeDetails,
  setTradeDetails,
} = accountMetricsSlice.actions;

export default accountMetricsSlice.reducer;
